import { Component, TemplateRef, ViewChild, inject } from "@angular/core";
import { CacheBehavior, CoreAppInterfaceService, CoreAuthenticationEvent, CoreAuthenticationService, CoreDeviceService, CoreHttpService, CorePendingQueueService, CoreUserProfileService, InterceptorConfig, InterceptorDisplayType, NotificationPopupService, NotificationProcessService, NotificationService, CoreCacheService, PingService, SoundService, CoreDeviceComponent, ConfigurationSet, CoreConfigurationService } from "@ftr/owa-core";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterOutlet } from "@angular/router";
import {
  Job,
  JobEAService,
  JobLockoutService,
  JobPreloaderService,
  JobsService,
  JobTechService,
  NotificationHandlerService,
  ProfileStatus,
} from "@ftr/owa-jobs";
import {
  combineLatest,
  combineLatestWith,
  distinctUntilChanged,
  first,
  mergeAll,
  mergeMap,
  Observable,
  of,
  ReplaySubject,
  Subject,
  Subscription,
  timer,
  bindCallback,
  map,
  from
} from "rxjs";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { TimeCard, Lunch, TimekeepingService, TkTimekeepingPreloaderService, TimekeepingModule } from "@ftr/owa-timekeeping";
import { BannerNotificationsComponent, OwaMessagingService, ChannelList, Channel } from "@ftr/owa-messaging";
import { filter, take, takeUntil, withLatestFrom } from "rxjs/operators";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { DfFormsService } from "@ftr/owa-dynamicforms";
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";
import { AlertModel, CommonAlertComponent } from "@ftr/common-ui-components";
import { DiagnosticsNotificationHandlerService } from "@ftr/owa-facilities";
import { differenceInSeconds } from "date-fns";
import { environment } from "src/environments/environment";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
// import { FirebaseAppMessagingService } from "./firebase/firebase.service";

import { ReportedTimeCardStatusComponent } from "./reported-timecard-status-component/reported-timecard-status.component";
import { TechInformationComponent } from "./tech-information/tech-information.component";
import { NavigationComponent } from "./nav/navigation/navigation.component";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: true,
    imports: [ CoreDeviceComponent, ReportedTimeCardStatusComponent, TechInformationComponent, RouterOutlet, TimekeepingModule, NavigationComponent, BannerNotificationsComponent]
})
export class AppComponent {
  private _coreCfg = inject(CoreConfigurationService);
  private _coreAuthenticationService = inject(CoreAuthenticationService);
  private _coreProfileService = inject(CoreUserProfileService);
  private _coreHttpService = inject(CoreHttpService);
  private _coreDeviceService = inject(CoreDeviceService);
  private _coreCacheService = inject(CoreCacheService);
  private _soundService = inject(SoundService);
  private router = inject(Router);
  _activatedRoute = inject(ActivatedRoute);
  private _appInterface = inject(CoreAppInterfaceService);
  private _pingService = inject(PingService);
  private _pendingQueueService = inject(CorePendingQueueService);
  private notificationProcessService = inject(NotificationProcessService);
  private dialog = inject(MatDialog);
  private updater = inject(SwUpdate);
  private matBottomSheet = inject(MatBottomSheet);
  private _techService = inject(JobTechService);
  private _jobsService = inject(JobsService);
  private _jobsEaService = inject(JobEAService);
  private _messagingService = inject(OwaMessagingService);
  private _jobsPreloadService = inject(JobPreloaderService);
  private _timeKeepingPreloaderService = inject(TkTimekeepingPreloaderService);
  private _timekeepingService = inject(TimekeepingService);
  private diagnostNotificationHandlerService = inject(DiagnosticsNotificationHandlerService);
  private _dynamicFormsService = inject(DfFormsService);
  private _jobLockoutService = inject(JobLockoutService);
  private _jobsNotificationHandler = inject(NotificationHandlerService);



  title = "MTPN";

  lunch: boolean = false;
  public loggedIn: boolean | undefined;
  private loggedInSubject = new ReplaySubject(1);
  shouldShowUrgentMessage: boolean = false;
  @ViewChild("CommonModalPage") commonModal: TemplateRef<any> | undefined;
  profileStatus?: ProfileStatus;
  //Additional boolean to track if we need to allow profile to show or not
  hideLunch: boolean = false;
  showNewMessageNotification: boolean = false;
  unReadNotifications: any = [];
  timer$!: Observable<number> | undefined;
  currentTimeCard!: TimeCard;

  timerSubscription!: Subscription;
  currentLunchTime!: Lunch | null;
  interval: any;
  online: boolean = true;
  private pingServiceSubscription?: Subscription;
  private readonly localStorageKey = "buttonClickStartDay";
  isDevicePrimary: boolean = false;
  omegaMode: boolean = false;

  get loggedInObservable() {
    return this.loggedInSubject.pipe(distinctUntilChanged());
  }

  public get isOnLockout() {
    return this._jobLockoutService.isOnLockout();
  }

  unsubscribe = new Subject<void>();

  ngOnInit() {
    this.loggedIn = false;
    this.checkOmegaMode();
    this.updater.versionUpdates.subscribe((evt) => {
      switch (evt.type) {
        case "VERSION_DETECTED":
          console.log(`Downloading new app version: ${evt.version.hash}`);
          break;
        case "VERSION_READY":
          console.log(`Current app version: ${evt.currentVersion.hash}`);
          console.log(
            `New app version ready for use: ${evt.latestVersion.hash}`
          );
          this.dialog
            .open(CommonAlertComponent, {
              data: new AlertModel(
                "Update",
                "There is an update to the app available. Please refresh the page.",
                "Refresh"
              ),
            })
            .close((res: any) => {
              if (res) {
                window.location.reload();
              }
            });
          break;
        case "VERSION_INSTALLATION_FAILED":
          console.log(
            `Failed to install app version '${evt.version.hash}': ${evt.error}`
          );
          break;
      }
    });

    this.updater.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === "VERSION_READY")
      )
      .subscribe((evt) => {
        console.log("New version ready:", evt);
        this.dialog
          .open(CommonAlertComponent, {
            data: new AlertModel(
              "Update",
              "There is an update to the app available. Please refresh the page.",
              "Refresh"
            ),
          })
          .close((res: any) => {
            if (res) {
              window.location.reload();
            }
          });
      });

    this.updater.unrecoverable.subscribe((event) => {
      console.log("Unrecoverable error with the updater:", event);
      let anyWindow = window as any;
      if (anyWindow.appInterface?.messageNativeApp) {
        let whitescreenError = {
          action: "white_screen_error",
          payload: {
            errorMessage: event,
          },
        };
        anyWindow.appInterface.messageNativeApp(
          JSON.stringify(whitescreenError)
        );
      }
      this.dialog
        .open(CommonAlertComponent, {
          data: new AlertModel(
            "Error",
            "An error occurred that we cannot recover from:" +
              event.reason +
              "\n\nPlease reload the page.",
            "Refresh"
          ),
        })
        .close((res: any) => {
          if (res) {
            window.location.reload();
          }
        });
    });

    const interceptorConfig = new InterceptorConfig(
      "",
      false,
      false,
      undefined,
      {
        type: InterceptorDisplayType.None,
      }
    );
    combineLatest([
      this._coreAuthenticationService.events,
      this._pingService.connectedSourceChanged$,
      this._coreDeviceService.primaryDeviceCheck,
    ])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([authEvent, connected, isPrimaryDevice]) => {
        switch (authEvent) {

          case CoreAuthenticationEvent.Authenticated:
            if (this.loggedIn == false) {
              this.loggedIn = true;
              //this.firebaseService.register();
              this._techService.getProfileStatus().subscribe();
              // @ts-ignore
              let qMStartObservable = bindCallback(QuantumMetricAPI.addEventListener.bind(QuantumMetricAPI));
              // @ts-ignore
              qMStartObservable("start")
                .pipe(
                  withLatestFrom(
                    this._coreProfileService
                      .getProfile()
                      .pipe(filter((value, idx) => value != null))
                  )
                )
                .subscribe(([_, userProfile]) => {
                  console.log("up", userProfile);
                  // @ts-ignore
                  QuantumMetricAPI.sendEvent(1, 2, userProfile.userName);
                  // @ts-ignore
                  QuantumMetricAPI.sendEvent(2, 8, userProfile.firstName);
                  // @ts-ignore
                  QuantumMetricAPI.sendEvent(3, 16, userProfile.lastName);
                });

              this._coreProfileService.getProfile().subscribe(() => {
                // Register for push notifications after the user is authenticated and get the profile
               // this.firebaseService.register();
                const canAccessTimeCards =
                  this._coreProfileService.checkAuthPermisions({
                    name: "TKS",
                    authorizations: [
                      "CanAccessTimeCards",
                      "CanReadOtherUsersTimeInfo",
                    ],
                    requiredAll: false,
                  });
                this._appInterface.notifyNativeAppOfReadiness();
                if (isPrimaryDevice) {
                  this._appInterface.requestPushNotificationToken();
                }
                if (canAccessTimeCards) {
                  this._timekeepingService.getCurrentTimeCard().subscribe();
                }
              });
            }
            // Wait for authenticated and connected to trigger the pending queue
            if (connected) {
              if (this._pendingQueueService.getAllTask().length > 0) {
                this._pendingQueueService.openProcessPendingQueue();
              }

              this._coreHttpService.getData(
                "/owaconfiguration/v1/settings/boldchatconfiguration",
                null,
                interceptorConfig,
                null,
                CacheBehavior.ReadCache | CacheBehavior.WriteCache
              );
              this._messagingService
              .getChannels()
              .pipe(
                map((channelList: ChannelList) => channelList.channels),
                mergeMap((channels: Channel[]) => from(channels)),
                mergeMap((channel: Channel) =>
                  this._messagingService.getMessagesForChannel(channel.id)
                )
              )
              .subscribe();
            }
            if (isPrimaryDevice) {
              this.isDevicePrimary = true;
              this._appInterface.requestPushNotificationToken();
            }
            break;
          case CoreAuthenticationEvent.Unauthenticated:
            // Ignore if disconnected so the tech doesn't get stuck logged out
            if (connected) {
              this.loggedIn = false;
              this.router.navigate(["/"]);
            }
        }
        this.loggedInSubject.next(this.loggedIn);
      });
    combineLatest([
      this._techService.profileStatus,
      this._coreProfileService.isContractor
        ? of(null)
        : this._timekeepingService.currentTimeCard,
    ])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([profileStatus, currentTimecards]) => {
        if (Array.isArray(currentTimecards)) {
          let [currentTimecard] = currentTimecards;
          this.currentTimeCard = currentTimecard;
        }
        this.profileStatus = profileStatus;
        let hasOpenLunch = false;
        if (this.currentTimeCard) {
          const openLunch = this.currentTimeCard?.lunches.find(
            (l) => !l.endTime
          );
          hasOpenLunch = !!openLunch;

          // Check if we have open lunches with expected Duration
          // If technicians timer expires their lunch, an audible alert will sound
          if (
            openLunch?.expectedDuration &&
            openLunch?.expectedDuration > 0 &&
            openLunch.id !== this.currentLunchTime?.id
          ) {
            this.currentLunchTime = openLunch;
            const timeDiff = openLunch.actualStartTime
              ? differenceInSeconds(
                  new Date(),
                  new Date(openLunch.actualStartTime)
                )
              : 0;
            const expectedDurationInSec = openLunch?.expectedDuration * 60;
            if (
              timeDiff <= expectedDurationInSec &&
              this.timer$ === undefined
            ) {
              this.timer$ = timer((expectedDurationInSec - timeDiff) * 1000);
              this.timerSubscription = this.timer$
                ?.pipe(take(1))
                .subscribe(() => {
                  this.onLunchTimerComplete();
                });
            }
          }
        }
        this.lunch = profileStatus.vxFieldStatus == "LUNCH" || hasOpenLunch;
      });
    this._techService.profileStatus
      .pipe(
        combineLatestWith(this.loggedInSubject),
        takeUntil(this.unsubscribe)
      )
      .subscribe(([profileStatus, loggedIn]) => {
        if (loggedIn) {
          this._appInterface.messageNativeApp({
            action: "status_update",
            payload: {
              status: profileStatus.vxFieldStatus,
            },
          });

          const clickTime = this._coreCacheService.getLocalStorageItem(
            this.localStorageKey,
            true
          );
          if (clickTime) {
            this.subscribeToNotifications(clickTime?.value);
          }
        }
      });

    this.router.events
      .pipe(
        filter(
          (r) => r instanceof NavigationEnd || r instanceof NavigationStart
        )
      )
      .subscribe((ne: any) => {
        if (ne instanceof NavigationEnd && ne.url.includes("messages")) {
          this.shouldShowUrgentMessage = false;
          this.showNewMessageNotification = false;
          //this.firebaseService.showNewMessageNotification.next(false);
          this.unReadNotifications?.forEach((n: { id: string }) => {
            this.notificationProcessService.markNotificationShown(n.id);
          });
          if (this.unReadNotifications?.length > 0) {
            this.unReadNotifications = [];
          }
        }
        if (
          ne instanceof NavigationStart &&
          ne.navigationTrigger === "popstate"
        ) {
          const ref = this.matBottomSheet._openedBottomSheetRef;
          const dialogOp = this.dialog.openDialogs?.length;
          if (ref || dialogOp > 0) {
            window.history.forward();
          }
          if (dialogOp > 0) {
            this.dialog.openDialogs[dialogOp - 1].close();
          } else if (ref) {
            ref?.dismiss();
          }
        }
        this.hideLunch =
          ne instanceof NavigationEnd && ne.url.toLowerCase() == "/profile";
        if (ne instanceof NavigationEnd) {
          this.checkOmegaMode();
        }
      });

    this.pingServiceSubscription =
      this._pingService.connectedSourceChanged$.subscribe((res: any) => {
        this.online = res;
      });

    this._soundService.downloadAudio("../assets/sounds/alarm.mp3");
    this._timekeepingService.navigateToTourTradeSubject.subscribe((data: boolean) => {
      if (data) {
        const tourTradePath = this.omegaMode
          ? ['omega', 'tools', 'tourTrades']
          : ['tools', 'tourTrades'];
        this.router.navigate(tourTradePath);
      }
    });
    this._jobsService.navigateToURHSubject$.subscribe((data: boolean) => {
      if (data) {
        window.open(environment.externalURLConfiguration.urhUrl, "_blank");
      }
    });
  }
  ngOnDestroy() {
    this.pingServiceSubscription?.unsubscribe();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  subscribeToNotifications(LoggedInDateTime?: any) {
    const canAccessFirebaseNotifications =
      this._coreProfileService?.checkAuthorization(
        "NTF",
        "CanAccessFirebaseNotifications"
      );
    if (!canAccessFirebaseNotifications) {
      if (
        !environment.coreConfiguration.notificationConfig
          .turnOffNotifications &&
        this.profileStatus &&
        this.profileStatus?.vxFieldStatus !== "LOGGED OFF"
      ) {
        new Promise<void>((resolve) => {
          this.notificationProcessService.startNotificationsTimer();
          resolve();
        })
          .then(() =>
            this.notificationProcessService.subscribeToNotifications(
              JSON.parse(LoggedInDateTime)
            )
          )
          .then(() =>
            this.notificationProcessService.enableNotificationSound()
          );
      } else {
        this.notificationProcessService.unSubscribeNotifications();
        this.notificationProcessService.disableNotificationSound();
        this._coreCacheService.clearLocalStorage(this.localStorageKey);
      }

      this.notificationProcessService.showNewMessageNotification.subscribe(
        (val) => {
          this.showNewMessageNotification = val;
        }
      );
    }

    this._timekeepingService.currentTimeCard.subscribe((currentTimecards) => {
      if (currentTimecards?.length > 0) {
        let [currentTimecard] = currentTimecards;
        const openLunch = currentTimecard?.lunches.find((l) => !l.endTime);
        if (!openLunch) {
          this.timerSubscription?.unsubscribe();
          this.timer$ = undefined;
          this.currentLunchTime = null;
        }
      }
    });
  }

  lunchTimerCalledEndVxField() {
    this._jobsService.jobs.pipe(first()).subscribe((jobs: Job[]) => {
      let openJobEa = jobs.find(
        (job) =>
          job.type == "EA" &&
          job.name?.toUpperCase() == "LUNCH" &&
          job.status.toUpperCase() != "COMPLETED"
      );
      if (openJobEa) {
        this._jobsEaService
          .endEmployeeActivity(openJobEa.name!, openJobEa.jobId!, {
            notes: "close lunch",
          })
          .subscribe();
      }
    });
  }

  private checkOmegaMode(): void {
    let route: ActivatedRoute | null = this._activatedRoute.root;
    while (route) {
      if (route.snapshot.data['omegaMode']) {
        this.omegaMode = true;
        return;
      }
      route = route.firstChild;
    }
    this.omegaMode = false;
  }

  onLunchTimerComplete() {
    if (!this._soundService.getSound("alarm")) {
      this._soundService.registerSound("alarm", "../assets/sounds/alarm.mp3");
    }
    this.manageMobileAlarm(true);
    let count = 1;
    this.interval = setInterval(() => {
      count++;
      if (this.online) {
        this._soundService.playSound("alarm");
      } else {
        this._soundService.playSoundOffline("alarm");
      }
      if (count > 7) {
        clearInterval(this.interval);
      }
    }, 2000);
  }

  endLunchAlarm(event: any) {
    if (event) {
      clearInterval(this.interval);
      this._soundService.resetSound();
      this.manageMobileAlarm(false);
    }
  }

  manageMobileAlarm(isStartAlarm: boolean) {
    // this code is for mobile native app start/stop alarm event
    let anyWindow = window as any;
    if (anyWindow.appInterface?.webAppReady) {
      if (isStartAlarm) {
        anyWindow.appInterface?.startLunchAlarm();
      } else {
        anyWindow.appInterface?.stopLunchAlarm();
      }
    }
  }
}
